import * as React from 'react';

import * as styles from './MortgageOffersTable.css';

export const MortgageOffersTable: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles['container']} data-testid="MortgageOffersTable">
      {children}
    </div>
  );
};
